import type React from "react";
import {memo} from "react";
import {useParams} from "react-router-dom";

import {useWipLevelV2} from "~/api/hooks/useWipLevelV2";
import AppHeader from "~/component/common/AppHeader";
import EditButton from "~/routes/page/play-level/buttons/EditButton";
import {RestartButton} from "~/routes/page/play-level/buttons/RestartButton";

const PlayTestLevel: React.FC = memo(() => {
  const {id} = useParams<{id: string}>();
  const {data: level} = useWipLevelV2({id});
  const parentPath = `/create/${id}`;

  return (
    <div className="flex flex-col w-screen min-h-screen text-white relative pointer-events-none">
      <AppHeader title={level?.name} parentPath={parentPath} />
      <div className="fixed bottom-2 left-1/2 transform -translate-x-1/2 z-50 pointer-events-auto flex justify-center gap-2">
        <EditButton />
        <RestartButton />
      </div>
    </div>
  );
});

export default PlayTestLevel;
